const mxn = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });

// 1234.5 -> "$1,234.50"
export const formatMoney = (amount) => mxn.format(Number(amount) || 0);
